export default "__VITE_ASSET__S8906Tle__"